export const Dashboard = () => <div className='bpm-copytiger'>Coming soon...</div>;
